import { useUIStore } from '../../stores';
import { useState } from 'react';

export function Header() {
  const theme = useUIStore((state) => state.theme);
  const setTheme = useUIStore((state) => state.setTheme);
  const sidebarMobileOpen = useUIStore((state) => state.sidebarMobileOpen);
  const setSidebarMobileOpen = useUIStore((state) => state.setSidebarMobileOpen);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // 跳转到新闻页面并带上搜索词
      window.location.href = `/news?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-[56px] bg-primary z-50 flex items-center justify-between px-4 lg:px-6">
      {/* Left: Logo & Menu Toggle */}
      <div className="flex items-center gap-3">
        {/* Mobile Menu Button */}
        <button
          className="lg:hidden p-2 rounded-md text-white/70 hover:text-white hover:bg-white/10 transition-fast"
          onClick={() => setSidebarMobileOpen(!sidebarMobileOpen)}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Logo */}
        <a href="/" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white/15 rounded-md flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6c-2 3-2 6 0 9" />
              <path d="M12 6c2 3 2 6 0 9" />
              <line x1="6" y1="12" x2="18" y2="12" />
            </svg>
          </div>
          <div className="hidden sm:block">
            <div className="font-heading font-bold text-lg text-white leading-tight">羽绒行情</div>
            <div className="text-xs text-white/60 leading-tight">全能信息助手</div>
          </div>
        </a>
      </div>

      {/* Center: Search */}
      <div className="hidden md:flex items-center">
        {searchOpen ? (
          <form onSubmit={handleSearch} className="flex items-center gap-2 bg-white/20 rounded-md px-3 py-1.5">
            <button
              type="submit"
              aria-label="提交搜索"
              className="text-white/80 hover:text-white transition-fast disabled:text-white/35"
              disabled={!searchQuery.trim()}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索新闻..."
              className="bg-transparent text-white text-sm placeholder:text-white/50 outline-none w-48"
              autoFocus
              onBlur={() => { if (!searchQuery) setSearchOpen(false); }}
            />
            <button
              type="button"
              onClick={() => { setSearchOpen(false); setSearchQuery(''); }}
              className="text-white/60 hover:text-white"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </form>
        ) : (
          <button
            onClick={() => setSearchOpen(true)}
            className="flex items-center gap-2 bg-white/12 rounded-md px-3 py-1.5 hover:bg-white/20 transition-fast"
          >
            <svg className="w-4 h-4 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <span className="text-sm text-white/60">搜索品种、新闻...</span>
          </button>
        )}
      </div>

      {/* Right: Theme Toggle */}
      <div className="flex items-center gap-2">
        <button
          onClick={toggleTheme}
          className="w-9 h-9 rounded-md flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-fast"
        >
          {theme === 'light' ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>
      </div>
    </header>
  );
}
